module.exports = {"id":"233096","name":"Denzel Dumfries","rating":"72","photo":"./data/images/photos/1/233096.png","club":{"name":"sc Heerenveen","logo":"./data/images/clubs/scHeerenveen.png"},"positions":["DD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DenzelDumfries0.json
// module id = 1059
// module chunks = 0